"use strict";
var container_1 = require("./blot/abstract/container");
var format_1 = require("./blot/abstract/format");
var leaf_1 = require("./blot/abstract/leaf");
var scroll_1 = require("./blot/scroll");
var inline_1 = require("./blot/inline");
var block_1 = require("./blot/block");
var embed_1 = require("./blot/embed");
var text_1 = require("./blot/text");
var attributor_1 = require("./attributor/attributor");
var class_1 = require("./attributor/class");
var style_1 = require("./attributor/style");
var store_1 = require("./attributor/store");
var Registry = require("./registry");
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Parchment;



//////////////////
// WEBPACK FOOTER
// ./~/parchment/src/parchment.ts
// module id = 2
// module chunks = 0